import { render, staticRenderFns } from "./ApplicationStatus.vue?vue&type=template&id=651ea880"
import script from "./ApplicationStatus.vue?vue&type=script&lang=js"
export * from "./ApplicationStatus.vue?vue&type=script&lang=js"
import style0 from "./ApplicationStatus.vue?vue&type=style&index=0&id=651ea880&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports